<template lang="pug">
  div.product
    router-link(:to="{name: 'productdetail', params: {id: item.id}}")
      div.cover
        picture
          source(:srcset="`${item.images[0]}`", media="(max-width: 480px)")
          img(:src="`${item.images[0]}`", alt="cover")
          //- source(:srcset="`${item.picture[0]}?x-oss-process=style/stance-product`", media="(max-width: 480px)")
          //- img(:src="`${item.picture[0]}?x-oss-process=style/stance-product`", alt="cover")
        //- div.badge
          span.new NEW
    div.info#info
      header
        div.type {{item.series}}
        //- div.extra
          i.icon.iconfont.icon-butterblend-icon
      section
        div.info
          div.name {{item.name}}
          div.price ¥{{item.price}}
        //- div.bag-close
          button.toggle.bag(v-if="showBag", @click="toggle")
            i.icon.iconfont.icon-shopping-bag-icon
          button.toogle.close(v-else, @click="toggle")
            i.close.icon.iconfont.icon-close-menu-icon
      //- div.add-to-bag-part(v-if="!showBag")
          p 添加到购物车
          div.sizes
            div.size.active
              span x
              i.indicator.iconfont.icon.icon-checkmark-icon
            div.size
              span l
              i.indicator.iconfont.icon.icon-checkmark-icon
            div.size.disabled
              span xl
              i.indicator.iconfont.icon.icon-checkmark-icon
            div.size.add-success
              span xxl
              i.indicator.iconfont.icon.icon-checkmark-icon
</template>
<script>
export default {
  name: 'Product',
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      showBag: true
    }
  },
  methods: {
    toggle () {
      this.showBag = !this.showBag
    },
    addToBag () {}
  },
  components: {}
}
</script>
<style lang = "scss" scoped>
.product {
      padding: 0 .15625rem 1.875rem;

}
a {
  height: 0;
  padding-top: 100%;
  display: block;
  position: relative;

}
header,
section {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
button {
  background: transparent;
  border: none;
}
.cover {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  background: #f8f8f8;
  background-blend-mode: multiply;
}

.cover img {
  height: 100%;
  width: 100%;
  background: none;
  -webkit-backface-visibility: hidden;
  transition: opacity 0.4s ease-in-out;
  object-fit: contain;
  object-position: 50% 65%;
  mix-blend-mode: multiply;
}

.badge {
  position: absolute;
  font-size: 0.6875rem;
  line-height: 1em;
  text-transform: uppercase;
  color: #fff;
  top: 0;
  left: 0.3rem;
  -webkit-transform: rotate(270deg) translate(-100%);
  transform: rotate(270deg) translate(-100%);
  -webkit-transform-origin: top left;
  transform-origin: top left;
  z-index: 1;
}

.badge span {
  color: #fff;
  padding: 0.25rem 0.4375rem 0.1875rem;
  text-transform: uppercase;
}
.badge .new {
  background: #1a1a1a;
}

.name {
  font-weight: 400;
  text-transform: uppercase;
  line-height: 2rem;
  color: #1a1a1a;
}
.price {
  font-size: 0.75rem;
  color: #1a1a1a;
}
#info {
  margin-top:0.9375rem;
}
.bag-close {
  .bag .icon {
    color: #0080a3;
    font-size: 1.5rem;
  }
  .close {
    color: #0080a3;
    font-size: 1rem;
  }
}

.add-to-bag-part p {
  font-weight: 400;
  text-transform: uppercase;
  margin: 1.25rem 0 0.4375rem;
  text-align: center;
  color: #1a1a1a;
}

.sizes {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
}

.size {
  width: 3rem;
  height: 3rem;
  border-radius: 3px;
  border: 1px solid #b7b7bf;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.size.active {
  border-color: #1a1a1a;
}
.size .indicator {
  display: none;
  font-size: 0.5rem;
}

.size.add-success {
  border: 2px solid #0080a3;
  color: #0080a3;
}

.size.add-success span {
  display: none;
}
.size.add-success .indicator {
  display: block;
}

.size.disabled {
}

.size text {
  font-size: 0.875rem;
  font-weight: bold;
  color: #1a1a1a;
}
</style>
